module.exports = __webpack_public_path__ + "img/vegetable-kohlrabi-350x184.e519a997.jpg";